<template>
    <button
        class="text-button"
        @click="$emit('click')"
        :disabled="disabled"
        :class="{ danger, disabled }"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
  name: "TextButton",
  props: {
    danger: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
button {
    font-weight: 700;
    font-size: $font-size-md;
    line-height: $font-size-md;
    color: $blue-navy;
    padding: $padding-md $padding-lg;
    background-color: transparent;
    letter-spacing: 1px;
    border: none;
    outline: 0;
    cursor: pointer;
    border-radius: $border-radius-md;
    position: relative;
    box-shadow: 0 0 0 0px $blue-gray-dark;
    transition: $transition-simple-xtra-fast;

    &:hover {
        background-color: $blue-gray-light;
    }

    &:focus {
        background-color: $blue-gray-light;
    }

    &:focus,
    &:active {
        box-shadow: 0 0 0 2px $blue-gray-dark;
    }

    &:active {
        background-color: $blue-gray-dark;
    }

    &.danger {
        color: $red-active;
        box-shadow: 0 0 0 0px $red-light;

        &:focus {
            background-color: $red-xtra-light;
        }

        &:focus,
        &:active {
            box-shadow: 0 0 0 2px $red-light;
        }

        &:hover,
        &:active {
            color: $red-dark;
            background-color: $red-light;
        }
    }

    &.disabled {
        color: $label-gray;
        cursor: not-allowed;

        &:focus,
        &:hover,
        &:active {
            background-color: transparent;
            box-shadow: 0 0 0 0px $blue-gray-dark;
        }
    }
}
</style>
